import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@chilecompra/react-kit/components'
import { Divider, Grid } from './QuoteStepTwo.styles'

/**
 * The BasicInformation's component.
 */
const BasicInformation = props => {
  const { isDownToTiny, name, quoteCode } = props

  return (
    <>
      <Grid container margin="16px 0 24px">
        <Grid item xs={12} sm={4}>
          <Typography color="black1" fontWeight="bold" variant="body2">
            Nombre Compra Ágil
          </Typography>
        </Grid>
        <Grid item xs={12} sm padding={isDownToTiny ? '8px 0 0' : undefined}>
          <Typography color="black1" variant="body2">
            {name}
          </Typography>
        </Grid>
      </Grid>
      <Divider />
      <Grid container margin="16px 0 24px">
        <Grid item xs={12} sm={4}>
          <Typography color="black1" fontWeight="bold" variant="body2">
            ID Compra Ágil
          </Typography>
        </Grid>
        <Grid item xs={12} sm padding={isDownToTiny ? '8px 0 0' : undefined}>
          <Typography color="black1" variant="body2">
            {quoteCode}
          </Typography>
        </Grid>
      </Grid>
      <Divider />
    </>
  )
}

BasicInformation.defaultProps = {
  isDownToTiny: false,
  name: '',
  quoteCode: ''
}

BasicInformation.propTypes = {
  isDownToTiny: PropTypes.bool,
  name: PropTypes.string,
  quoteCode: PropTypes.string
}

export default BasicInformation
